import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSelectChange, MatSelect } from "@angular/material/select";
import { MatTableDataSource } from "@angular/material/table";
import { PortalAdminService } from "../../services/portal-admin-service/portal-adimin.service";
import { MrcUser } from "../../models/mrc-user";
import { MrcGroup } from "../../models/mrc-group";
import { MrcUserEmail } from "../../models/mrc-user-email";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";

@Component({
    selector: "pa-mrc",
    templateUrl: "./mrc.component.html",
    styleUrls: ["./mrc.component.scss"],
    standalone: false
})
export class MrcComponent implements OnInit {
  @ViewChild("mySelect") mySelect: MatSelect;

  internalId: string;

  displayedColumns = ["user", "reportsTo", "groupName"];
  // dataSource: MatTableDataSource<MrcUser>;
  dataSource: MatTableDataSource<MrcUser> = new MatTableDataSource<MrcUser>();
  usersLength: number;
  groups: MrcGroup[];
  isEdit = false;
  userIndex: number;
  selectedGroupName: string;
  editGroupName: string;
  newUser: MrcUser = new MrcUser();

  userEmail: string;
  userIsValid: boolean;
  validateWarn = false;
  canAddUser = true;
  userAdded = false;

  showTable: boolean;
  isLoading: boolean;

  private paginator: MatPaginator;
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  constructor(
    private portalAdminService: PortalAdminService,
    private router: Router
  ) {
    const unEncoded = localStorage.getItem("internalID");
    this.internalId = encodeURI(unEncoded);
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.isLoading = true;
    this.dataSource.paginator = this.paginator;
    this.portalAdminService.getUsers().subscribe((usersRes: MrcUser[]) => {
      if (usersRes.length > 0) {
        this.showTable = true;
        this.dataSource = new MatTableDataSource(usersRes);
        this.usersLength = usersRes.length;
        this.isLoading = false;
      } else {
        this.showTable = false;
        this.isLoading = false;
      }
    });
    this.portalAdminService.getGroups().subscribe((groupRes: MrcGroup[]) => {
      this.groups = groupRes;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  validateUser() {
    this.isLoading = true;
    this.portalAdminService
      .checkEmail(encodeURIComponent(this.userEmail))
      .subscribe(
        (emailRes: MrcUserEmail) => {
          this.userIsValid = true;
          this.newUser.auth0Identifier = emailRes.auth0Identifier;
          this.newUser.email = emailRes.email;
          this.isLoading = false;
          this.validateWarn = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          console.log(err);
          if (err.status !== 200) {
            this.userIsValid = false;
            this.validateWarn = true;
            setTimeout(() => {
              this.validateWarn = false;
            }, 2000);
          }
        }
      );
  }

  selectGroupName(event) {
    this.canAddUser = false;
    this.newUser.groupName = event.value;
    this.newUser.bdfAmount = "";
    this.newUser.holdingSectorNumber = "";
    this.newUser.reportsTo = "";
    this.newUser.userAccessId = 0;
    this.newUser.userId = 0;
  }

  addUser() {
    this.isLoading = true;
    this.portalAdminService.addUser(this.internalId, this.newUser).subscribe(
      (addUserRes: MrcUser) => {
        // console.log(addUserRes)
        this.updateTable();
        this.userIsValid = false;
        this.canAddUser = true;
        this.userEmail = "";
        this.selectedGroupName = "";
        this.userAdded = true;
        setTimeout(() => {
          this.userAdded = false;
        }, 1500);
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.log(err);
        if (err.status === 403 || err.status === 401) {
          this.router.navigate(["/access-denied"]);
        } else {
          this.router.navigate(["/error"]);
        }
      }
    );
  }

  editUser(index: number, userGroupName: string) {
    this.editGroupName = userGroupName;
    this.userIndex = index;
    this.isEdit = true;
    this.openGroupName();
  }
  openGroupName() {
    setTimeout(() => {
      this.mySelect.open();
      this.mySelect.focus();
    }, 100);
  }

  editGroup(event: MatSelectChange) {
    this.editGroupName = event.value;
  }

  closeEdit(user: MrcUser) {
    user.groupName = this.editGroupName;
    this.isLoading = true;
    this.portalAdminService
      .updateUser(this.internalId, user)
      .subscribe((updateRes) => {
        this.updateTable();
      });
    this.isEdit = false;
    this.userIndex = -1;
  }

  updateTable() {
    this.portalAdminService.getUsers().subscribe((usersRes: MrcUser[]) => {
      if (usersRes.length > 0) {
        this.showTable = true;
        this.dataSource = new MatTableDataSource(usersRes);
        this.usersLength = usersRes.length;
        this.isLoading = false;
      } else {
        this.showTable = false;
        this.isLoading = false;
      }
    });
  }
}
